<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading">
        <v-container class="py-10 py-md-13 py-lg-16 item">
          <v-row v-if="items.length" justify="center">
            <v-col
              :class="{ 'mt-10 mt-md-13 mt-lg-16': keyItems > 0 }"
              cols="12"
              v-for="({ img, video, title, text }, keyItems) in items"
              :key="keyItems"
            >
              <TitleWidget class="text-center">{{ title }}</TitleWidget>
              <v-row class="mt-10 mt-md-16">
                <v-col cols="12" sm="6">
                  <div
                    v-if="text"
                    class="grey--text text--darken-1 ck-content item-text"
                    v-html="text"
                  ></div>
                </v-col>
                <v-col v-if="video" class="video">
                  <iframe
                    :src="`https://www.youtube.com/embed/${getYoutubeCode(
                      video
                    )}`"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col v-else-if="img" cols="12" sm="6">
                  <img
                    class="d-block item-img"
                    :src="files + img + '?resize=1&w=960'"
                    :alt="title"
                    width="100%"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-alert v-else type="info" width="100%">
            Nenhum conteúdo adicionado até o momento.
          </v-alert>
        </v-container>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import { getYoutubeCode } from "../../utils/getYoutubeCode";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getYoutubeCode,
  },
  components: {
    LoadingWidget,
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.images-grid-list {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 960px) {
    gap: 5px;
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  img {
    aspect-ratio: 16 / 12;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
